export const purchase = {
  label: 'Purchase',
  from: 'Purchase from',
  to: 'Purchase for',
  amount: 'Amount',
  mobileNumber: 'Mobile Number',
  customerNumber: 'Customer Number',
  voucherNumber: 'Voucher Number',
  voucherNumberTelkomselPackageData: 'Voucher SN',
  placeholder: {
    autocomplete: 'Select the Purchase',
    operator: 'Select the Operator',
    reloadType: 'Select Reload Type',
    serviceType: 'Select Service Type',
    phoneNumberNote: 'Please ensure entered phone number is correct',
  },
  modal: {
    title: 'Purchase for {billerName}',
    paymentCode: 'Payment Code',
    operator: 'Mobile Operator',
  },
  errorMessage: {
    invalidPaymentCode: 'Invalid Payment Code Number',
  },
};
